import reducer from "./Reducers/index"
import { legacy_createStore as createStore } from "redux"

export const store = createStore(reducer);